export default [
  {
    position: "absolute",
    top: 45,
    left: 47.5,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "navigatingP2.mTitleOne",
    mBody: "navigatingP2.mBodyOne",
    isVideo: true,
    videoThumb: "SP-Employment-Change-Request-Thumb",
    videoURL: "SP-Employment-Change-Request.mp4",
    vidIcon: true,
    id: "SP_TeamMember_Video_ChangeRequest",
    index: 0
  },
  {
    position: "absolute",
    top: 5.3,
    left: 88,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "teamMemberP2.ttTextOne",
    hover: false,
    tooltipClass: "left",
    id: "SP_TeamMeber_Navigation_StevePendleton",
    index: 1
  },
  {
    position: "absolute",
    top: 12.5,
    left: 5,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "teamMemberP2.mTitleTwo",
    mBody: "teamMemberP2.mBodyTwo",
    id: "SP_TeamMeber_Info_EasyLayout",
    infoIcon: true,
    isAction: false,
    index: 2
  },
];
